module.exports = __webpack_public_path__ + "static/img/main.ab0a9a0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/infoService/2/main.png
// module id = xl5x
// module chunks = 1